<template>
  <el-dialog title="修改账号密码" @close="close" :visible.sync="box" width="40%" :append-to-body="true" :modal-append-to-body="true">
    <el-form :model="form" ref="form" label-width="120px">


      <el-form-item label="账号名称" prop="username">
        <el-input v-model="form.username" readonly></el-input>
      </el-form-item>



      <el-form-item label="旧密码" prop="password" >
        <el-input v-model="form.password" placeholder="请输入账号旧密码"></el-input>
      </el-form-item>



      <el-form-item label="新密码" prop="newpassword1" >
        <el-input v-model="form.newpassword1" placeholder="请输入账号密码"></el-input>
      </el-form-item>



      <el-form-item label="确认新密码" prop="surePasswd">
        <el-input v-model="form.surePasswd" placeholder="请输入账号密码"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handlePassword">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import store from "@/store";
import api from "@/api/projectApi";
export default {
  name: "password",
  props: { box: Boolean },
  data() {
    return {
      box: '',
      form: {
        username:"",
        password:"",
        newpassword1:"",
        surePasswd:"",

      }
    };
  },
  created() {
    this.form.id = store.getters.userInfo.id
    this.form.username = store.getters.userInfo.username
    // console.log(this.box = box, "box");
  },
  mounted() {

  },
  computed: {
  },
  props: [],
  methods: {
    handlePassword() {
      if (!this.form.password){
        this.$message.error('请输入旧密码！')
        return
      }
      if (!this.form.newpassword1){
        this.$message.error('请输入新密码！')
        return
      }
      if (this.form.newpassword1 && (this.form.newpassword1.length <6 || this.form.newpassword1.length >12)){
        this.$message.error('密码只允许6到12位！')
        return
      }
      if (!this.form.surePasswd){
        this.$message.error('请输入确认新密码！')
        return
      }
      if (this.form.newpassword1!=this.form.surePasswd){
        this.$message.error('密码不一致,请确认！')
        return
      }
      this.$baseConfirm('是否修改？').then(() => {
          this.$http({
            url: api.sysUser.updatePassWordUrl,
            method: 'post',
            data: this.form,
            isLoading: true,
            modalStrictly: true,
          }).then(response => {
            this.$message({
              type: response.data.type,
              message: response.data.content
            });
            if (response.data.type == "success"){
              // this.$emit('commitPassword', false)
              this.$store.dispatch('LogOut').then(() => {
                this.$router.push({ path: '/login' })
              })
            }
          })
      })
    },
    close(){
      this.$emit('commitPassword', false)

    }
  },
  components: {}
};
</script>

<style lang="scss" scoped></style>
